module.exports = __webpack_public_path__ + "static/media/challenge_bac.c129de45.png";